<template>
    <div :id="TURNSTILE_CONTAINER_ID" />
</template>
